export interface ContactCenter {
  id?: string;
  uniqueId?: string;
  institution?: {
    id?: string;
    institutionUniqueId?: string;
    institutionName?: string;
    institutionShortform?: string;
  };
  isSystemContact?: boolean;
  callPhone?: string;
  smsPhone?: string;
  schedules?: {
    id?: string;
    uniqueId?: string;
    weekday?: string;
    startTime?: string;
    endTime?: string;
  }[];
  socialMedia?: {
    id?: string;
    uniqueId?: string;
    platform?: string;
    title?: string;
    handle?: string;
    icon?: string | null;
    url?: string;
  }[];
}


export enum SocialPlatform {
  Facebook = 'Facebook',
  Twitter = 'Twitter',
  Instagram = 'Instagram',
  Linkedin = 'Linkedin',
  Youtube = 'Youtube',
  Whatsapp = 'Whatsapp',
  Telegram = 'Telegram',
  Tiktok = 'Tiktok',
  Other = 'Other'
}
